module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Gh9xxj/tc-custom/9781504015998.jpg?1708811038999",
      "alt": "This image is the cover for the book Corpse That Never Was, The Mike Shayne Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Corpse That Never Was, The Mike Shayne Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Mike Shayne finds strange secrets hidden beneath the cover of a grisly double suicide")]), _c('br'), _c('br'), _vm._v(" It’s 10:30 pm, and Mike Shayne is sipping cognac, ruminating on the perfection of Lucy Hamilton’s fried chicken, when a shotgun fires upstairs. Following the acrid stench of gunpowder to a locked door halfway down the hall, Shayne has no choice but to batter it down, tumbling face first into the scene of a particularly ugly double suicide. The woman lies on the floor in the middle of the sitting room, her face twisted by the deadly kiss of cyanide. A few feet beyond her body is what remains of a man, his head obliterated by the shotgun’s blast."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The woman’s father is one of Miami’s power brokers, and he refuses to believe that his daughter would end her life over a silly affair. Isn’t it possible, he asks, that she was murdered? Convinced or not, Shayne is the only man ruthless enough to find out."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The Corpse That Never Was "), _c('i', [_vm._v("is the 45th book in the Mike Shayne Mysteries, but you may enjoy reading the series in any order.")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brett Halliday\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Brett Halliday (1904–1977) was the primary pseudonym of American author Davis Dresser. Halliday is best known for creating the Mike Shayne Mysteries. The novels, which follow the exploits of fictional PI Mike Shayne, have inspired several feature films, a radio series, and a television series. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0